import {  Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CreateAccCompanyDialog } from './create-ctas/createacc.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SettingsService } from '../../settings/settings.service';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatExpansionModule } from '@angular/material/expansion';
import { UpdateAccountCompanyDialog } from './actualizar-ctas/updateacc.component';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';



@Component({
    selector: 'ctas',
    templateUrl: './ctas.html',
    styleUrls: ['./ctas.less'],
    standalone: true,
    imports: [
      FormsModule,
      ReactiveFormsModule,
      CommonModule,
      MatButtonModule,
      MatFormFieldModule,
      MatExpansionModule,
      UpdateAccountCompanyDialog,
      MatInputModule,
      MatIconModule
    ]
})
export class CuentasBancarias implements OnInit, OnChanges {
  @Input() id_company: any;
  @Input() token: any;
  @Input() role: any;
  @Input() actualizar = 0;
  @Input() se_abrio_como_dialogo: boolean = false;

  has_accounts: boolean = false;
  sw_edit = true;
  all_accounts: any[] = [];
  @Input() companyRun!: string;
  valForm: FormGroup;

  @Input() bancos: any;
  @Input() cuentas: any;

  constructor(
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    fb: FormBuilder,
    public settings: SettingsService,
    private _formBuilder: FormBuilder
  ) {
    this.valForm = this._formBuilder.group({
      filter_cta: [''],
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.actualizar == 1) {
      this.reloadAccounts();
      this.actualizar = 0;
    }
  }

  async ngOnInit() {
    // await this.load_bancos();
    // await this.load_cuentas();
    this.load_accounts();
  }

  filtro = '';
  mostrarAccordion = false;
  async load_accounts() {

    try {
      this.all_accounts = [];
      
      const bd: any = await this.settings.get_query(1, 'cliente-inversionista/bank-accounts' + '/?filtro=' + this.filtro + '&company_id='+this.id_company);
      var body_data: any = bd._body;
      switch (bd.status) {
        case 201:
        case 200:
            console.log(body_data)
            if (body_data.info.accounts.length == 0) {
              this.has_accounts = true;
            } else {
              this.has_accounts = false;
            }

            for (let i = 0; i < body_data.info.accounts.length; i++) {
              const accountData = {
                id: body_data.info.accounts[i].id,
                banco: body_data.info.accounts[i].bank.name,
                proveedor: body_data.info.accounts[i].name,
                email: body_data.info.accounts[i].email,
                validated_status: body_data.info.accounts[i].validated == 0 ? 'not_checked' : 
                body_data.info.accounts[i].validated == 1 ? 'checked' : 
                body_data.info.accounts[i].validated == 2 ? 'error_checked' : 'pending_checked',
                validated_tooltip: body_data.info.accounts[i].validated == 0 ? 'Cuenta no validada' : 
                body_data.info.accounts[i].validated == 1 ? 'Cuenta validada' : 
                body_data.info.accounts[i].validated == 2 ? 'Cuenta con validación fallida' : 'Validación en progreso',
                validated_icon: body_data.info.accounts[i].validated == 0 ? 'do_not_disturb' : 
                body_data.info.accounts[i].validated == 1 ? 'check_circle' : 
                body_data.info.accounts[i].validated == 2 ? 'error' : 'loop',
                sw_edit: this.sw_edit,
                star: body_data.info.accounts[i].is_primary ? 'star' : 'star_border',
                star_class: body_data.info.accounts[i].is_primary ? 'add_primary' : 'add_primary_off',
                is_primary_text: body_data.info.accounts[i].is_primary ? 
                body_data.info.accounts[i].tipo_cuenta.name + ' - Cuenta Principal' : 
                body_data.info.accounts[i].tipo_cuenta.name,
                disabled_delete: body_data.info.accounts[i].is_primary,
                disabledButton: this.role == 'teso',
                run: body_data.info.accounts[i].rut,
                number: body_data.info.accounts[i].number,
                is_tercero: body_data.info.accounts[i].is_tercero,
                full_name: body_data.info.accounts[i].name,
                bank_selected: body_data.info.accounts[i].bank.id,
                account_selected: body_data.info.accounts[i].tipo_cuenta.id,
                token: this.token,
                bancos: this.bancos,
                cuentas: this.cuentas,
                id_company: this.id_company,
                companyRun: this.companyRun,
                info: this
              };
              
              this.all_accounts.push(accountData);
            }

            setTimeout(() => {
               this.mostrarAccordion = true;
            }, 200);




        break;
        default:

        break;
      }

    } catch (bd:any) {
      console.log(bd);
    }
  }

  buscar_cta() {
    let filtro = this.valForm.controls['filter_cta'].value;
    this.filtro = filtro;
    this.reloadAccounts();
  }

  reset_cta($e: any) {
    if ($e.target.value == '') {
      this.filtro = '';
      this.reloadAccounts();
    }
  }

  reloadAccounts() {
    this.mostrarAccordion = false;

    this.load_accounts();
  }

create_account() {
  console.log("Bancos antes de abrir diálogo:", this.bancos);
  console.log("Cuentas antes de abrir diálogo:", this.cuentas);
  
  let dialogRef = this.dialog.open(CreateAccCompanyDialog);
  
  dialogRef.componentInstance.info = this;
  dialogRef.componentInstance.id_company = this.id_company;
  dialogRef.componentInstance.token = this.token;
  dialogRef.componentInstance.bancos = this.bancos;
  dialogRef.componentInstance.cuentas = this.cuentas;

  dialogRef.afterClosed().subscribe((result) => {});
}

  // bancos: Banco[] = [];

  // async load_bancos() {
  //   try {
  //     const bd: any = await this.settings.get_query(1, '/bank/');
  //     var body_data: any = bd._body;

  //     console.log("AQUIII CUENTAS");
  //     switch (bd.status) {
  //       case 201:
  //       case 200:
  //         for (let i = 0; i < body_data.banks.length; i++) {
  //           this.bancos.push(body_data.banks[i]);
  //         }

  //         console.log("ESTE ES BANCOOOS", this.bancos);

  //         break;
  //       default:
  //         break;
  //     }
  //   } catch (bd: any) {
  //     console.log(bd, "CAYO EN EL CATCH")
  //   }
  // }

  // cuentas: Cuenta[] = [];
  //   async load_cuentas() {
  //   try {
  //     const bd: any = await this.settings.get_query(1, '/account-type/');
  //     var body_data: any = bd._body;
  //     switch (bd.status) {
  //       case 201:
  //       case 200:
  //         var body_data: any = bd._body;

  //         for (let i = 0; i < body_data.accounts.length; i++) {
  //           if (i != 1) {
  //             this.cuentas.push(body_data.accounts[i]);
  //           }
  //         }

  //         break;
  //       default:
  //         break;
  //     }
  //   } catch (bd: any) {
  //     console.log("AQUI LOAD_CUENTAS", bd);
  //   }
  // }

}

interface Banco {
  id: string;
  name: string;
}

export interface Cuenta {
  id: string;
  name: string;
}
